<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XP80X1/tc-custom/9781504073516.jpg?1700538178406" alt="This image is the cover for the book Gaia Trilogy Books One to Three, The Gold Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gaia Trilogy Books One to Three, The Gold Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The action-packed trilogy now in one volume—set in a water-starved world where international agents fight to keep doomsday at bay . . .</b><br/>  <br/> This three-in-one digital edition of the thrilling Gaia series includes:<br/>  <br/><b>Blue Gold</b><br/> Climate change and geopolitical tension have given rise to a new international threat: a world war over water. This vital resource has become a precious commodity, and some will stop at nothing to control its flow. When a satellite disappears over Iceland, Sim Atkins joins the Overseas Division to hunt for the terrorists responsible—a quest that will take him and his partner, Freda, to a billionaires’ tax haven in the middle of the Atlantic Ocean and into a web of deceit . . .<br/>  <br/><b>Rose Gold</b><br/> In the aftermath of war, tensions remain high and terrorism is a daily fact of life. But a mining base on the moon offers a rare example of international co-operation and a possible solution to the world’s energy problems. Yet not everyone on Earth is keen for this endeavour to succeed—and Sim Atkins’s plan to start a family with his wife may have to be put on hold . . .<br/>  <br/><b>White Gold</b><br/> Agent Atkins has returned home after surviving his last deadly mission, and all he can think about is finding the criminals responsible for a heinous act. But his fury and lust for revenge must be set aside when a nuclear warhead is stolen . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Barker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d01653e8